<template>
  <div style="height: 100%; position: relative;">
    <DashboardFilterChip :chip-color="chipColor" :chip-text="chipText"></DashboardFilterChip>
    <v-card style="height: 100%">
      <v-card-text>
        <v-row class="mt-3">
          <v-col cols="12" align="center">
            <h1>Headcount</h1>
            <br>
            <h2>{{ headCountData.headCount }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <pie-chart
              :data="{ 'High Billers': headCountData.highBillersCount, 'Low Billers': headCountData.lowBillersCount }"
              legend="bottom"
              loading="Loading..."
              :colors="['#99ff66', '#00ffff']"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" align="center"><h2>H: {{ headCountData.highBillersCount }}</h2></v-col>
          <v-col cols="6" align="center"><h2>L: {{ headCountData.lowBillersCount }}</h2></v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="center">
            <v-btn
              text
              color="primary"
              :disabled="disableButtons"
              @click="showHeadCountDetails"
            >
              Details
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="end">
            <v-btn
              v-if="!showFetchingDataGIF"
              color="primary"
              outlined
              class="ml-2"
              @click="refreshTile"
              style="float: left;"
              >
                <v-icon>refresh</v-icon>
            </v-btn>
            <i
              v-if="showFetchingDataGIF"
              class="mr-2"
            >
              Fetching Data
            </i>
            <v-progress-circular
              v-if="showFetchingDataGIF"
              :size="30"
              :width="7"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <i
              v-if="lastRefreshTime"
              class="ml-10 mr-5"
            >
              Last Update: {{ lastRefreshTime }}
            </i>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <DynamicModal
      :showModal="showHeadCountDetailsModal"
      :persistent="false"
      @clickOutside="closeHeadCountDetails"
      title="Headcount Details"
      maxWidth="800px"
    >
      <v-container fluid slot="title-buttons" class="py-1">
        <v-row justify="end">
          <v-btn
            icon
            depressed
            color="primary"
            @click="closeHeadCountDetails"
          >
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid slot="content">
        <HeadCountReportDetails
          :data="headCountData.headCountReportItems"
        ></HeadCountReportDetails>
      </v-container>
      <v-container fluid slot="buttons" class="pb-0 mb-0">
        <v-row>
          <v-col cols="12">
            <v-btn
              block
              depressed
              outlined
              @click="closeHeadCountDetails"
            >
              Close
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </DynamicModal>
  </div>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import { HeadCountReportDetails } from '@/components/dashboard/headCount/index'
import DashboardFilterChip from '@/components/dashboard/DashboardFilterChip'
import { mapActions } from 'vuex'
import { isJSONString } from '@/lib/miscellaneous'
import { getLocalTimeString } from '@/lib/display'

export default {
  components: {
    DashboardFilterChip,
    DynamicModal,
    HeadCountReportDetails
  },
  props: {
    businessEntityId: {
      type: Number,
      default: null
    },
    chipText: {
      type: String,
      default: 'All Business Entity'
    },
    chipColor: {
      type: String,
      default: 'primary'
    }
  },
  data () {
    return {
      showHeadCountDetailsModal: false,
      headCountData: {
        headCount: 0,
        highBillersCount: 0,
        lowBillersCount: 0,
        headCountReportItems: []
      },
      lastRefreshTime: null,
      showFetchingDataGIF: false,
      disableButtons: false
    }
  },
  methods: {
    ...mapActions('dashboard', [
      'getHeadcount'
    ]),
    showHeadCountDetails () {
      this.showHeadCountDetailsModal = true
    },
    closeHeadCountDetails () {
      this.showHeadCountDetailsModal = false
    },
    refreshTile () {
      this.showFetchingDataGIF = true
      this.disableButtons = true
      this.getHeadcount(this.businessEntityId).then((data) => {
        if (data) {
          let dateTimeNow = new Date()
          this.headCountData = data
          localStorage.setItem('dashboard:headcount', JSON.stringify(data))
          localStorage.setItem('dashboard:headcount-last-refresh-time', JSON.stringify(dateTimeNow.toUTCString()))
          this.lastRefreshTime = getLocalTimeString(dateTimeNow)
        }
        this.showFetchingDataGIF = false
        this.disableButtons = false
      })
    }
  },
  created () {
    if (localStorage.getItem('dashboard:headcount') && isJSONString(localStorage.getItem('dashboard:headcount'))) {
      this.headCountData = JSON.parse(localStorage.getItem('dashboard:headcount'))
    }
    if (localStorage.getItem('dashboard:headcount-last-refresh-time') && isJSONString(localStorage.getItem('dashboard:headcount-last-refresh-time'))) {
      let lastRefreshTime = new Date(JSON.parse(localStorage.getItem('dashboard:headcount-last-refresh-time')))
      this.lastRefreshTime = getLocalTimeString(lastRefreshTime)
    }
    this.refreshTile()
  }
}
</script>
